export function getDialog (state) {
  return state.name
}
export function allDialogs (state) {
  return state.names
}
